import { differenceInDays } from "date-fns";
import useUser from "../../providers/UserProvider/useUser";
import Card from "../../ui/Card/Card";
import { InfoSquare } from "../../ui/Icon/Icon";
import ProgressBar from "../../ui/ProgressBar/ProgressBar";
import styles from "./KeywordUsagePopoverContent.module.scss";
import { useMemo } from "react";
import Button from "../../ui/Button/Button";

function getUsageResetTimeframe(daysUntilReset: number) {
  const weeks = Math.floor(daysUntilReset / 7);

  if (weeks > 0) {
    return `${weeks} week${weeks > 1 ? "s" : ""}`;
  }

  return `${daysUntilReset} day${daysUntilReset > 1 ? "s" : ""}`;
}

function KeywordUsagePopoverContent({
  openCreditsModal,
}: {
  openCreditsModal: () => void;
}) {
  const {
    keywordQueryCreditsRemaining,
    billingInfo: { keywordQueriesPerMonth, currentMonthEnd },
  } = useUser();

  const daysUntilReset = useMemo(
    () =>
      currentMonthEnd
        ? differenceInDays(new Date(currentMonthEnd), new Date())
        : 0,
    [currentMonthEnd],
  );

  return (
    <Card className={styles.card}>
      <div className={styles.cardHeader}>
        <div className={styles.cardTitle}>
          <span>Keyword credits left</span>
          <span>
            {keywordQueryCreditsRemaining} / {keywordQueriesPerMonth}
          </span>
        </div>
        <ProgressBar
          maxValue={keywordQueriesPerMonth}
          currentValue={keywordQueryCreditsRemaining}
        />

        <div className={styles.usageResets}>
          <span>Usage resets in {getUsageResetTimeframe(daysUntilReset)}</span>
        </div>
      </div>
      <div className={styles.cardInfo}>
        <InfoSquare size="small" />
        <span>
          One keyword credit is used when you search, apply filters or navigate
          to a new page
        </span>
      </div>

      <div className={styles.buttonWrapper}>
        <Button
          variant="outline"
          onClick={openCreditsModal}
          className={styles.button}
        >
          Purchase extra credits
        </Button>
      </div>
    </Card>
  );
}

export default KeywordUsagePopoverContent;
